import React from "react";
import { Grid, Typography, Button, CardMedia, Box, Chip, Divider } from "@mui/material";
import { size, COLORS } from "../../utils";

const publications = [
    {
        title: "ICETMCP-2026 (Edition 1)",
        description:
            "ICETMCP-2026 (Edition 1) marked the successful inaugural edition of the International Conference on Emerging Trends in Machine Learning, Computer Vision, and Pattern Recognition. The conference brought together researchers, academicians, industry professionals, and students to exchange innovative ideas and present cutting-edge research in artificial intelligence, data science, cybersecurity, cloud computing, IoT, and related technologies. The official conference portal provides access to conference proceedings, downloadable resources, and event highlights.",
        buttonText: "Edition 1",
        href: "https://icetmcp2026.com/landingpage/downloads",
        image: "/assets/images/publications/edition1.jpg",
    },
    {
        title: "ICETMCP-2026 (Edition 2)",
        upcoming: true,
        description:
            "ICETMCP-2026 (Edition 2) is the upcoming edition of the International Conference on Emerging Trends in Machine Learning, Computer Vision, and Pattern Recognition. Building on the success of the inaugural conference, it aims to bring together researchers, academicians, industry experts, and students to explore the latest advancements in artificial intelligence, machine learning, computer vision, data science, cybersecurity, and emerging technologies. Visit the official conference website for updates on paper submissions, important dates, keynote speakers, registration, and upcoming announcements.",
        buttonText: "Edition 2",
        href: "https://icetmcp2026.com/",
        image: "/assets/images/publications/edition2.jpg",
    },
    {
        title: "Title: Handbook of Explainable Artificial Intelligence (XAI): Methods, Models, and Applications",
        upcoming: true,
        description:
            "Artificial Intelligence has become a cornerstone of innovation across healthcare, finance, manufacturing, transportation, cybersecurity, education, agriculture, and smart cities. Despite remarkable advances in deep learning and foundation models, many AI systems continue to function as \"black boxes,\" making their decisions difficult to interpret and trust. The Handbook of Explainable Artificial Intelligence (XAI): Methods, Models, and Applications provides a comprehensive and up-to-date reference on the principles, methodologies, algorithms, tools, evaluation techniques, and practical applications of Explainable AI.",
        buttonText: "Call For Chapters",
        href: "/assets/images/publications/Call_For_Chapters.png",
        image: "/assets/images/publications/Call_For_Chapters.png",
        download: true,
    },
];

export default function Publications() {
    return (
        <Grid
            container
            direction="column"
            alignItems="center"
            mt={size({ p: 10, h: true })}
            rowGap={size({ p: 8, h: true })}
        >

            <Grid
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: '1rem'
                }}
            >
                <Typography
                    sx={{
                        fontFamily: "Archia",
                        fontSize: size({ p: 2.4 }),
                        fontWeight: 700,
                        color: COLORS.C2,
                        textAlign: "center",
                    }}
                >
                    Our Research Archives
                </Typography>

                <Typography
                    sx={{
                        width: size({ p: 40 }),
                        fontFamily: "Archia",
                        fontSize: size({ p: 1 }),
                        fontWeight: 400,
                        color: COLORS.C1 + "B0",
                        textAlign: "center",
                    }}
                >
                    Discover our curated collection of research publications, conference proceedings, and upcoming academic works that inspire innovation and contribute to the future of intelligent technologies.
                </Typography>

            </Grid>

            <Grid
                container
                direction="column"
                width={size({ p: 75 })}
                rowGap={size({ p: 6, h: true })}
            >
                {publications.map((item, index) => (
                    <Grid item key={index}>
                        <Grid
                            container
                            direction={{
                                xs: "column",
                                md: index % 2 === 0 ? "row" : "row-reverse",
                            }}
                            alignItems="center"
                            sx={{
                                p: size({ p: 4 }),
                                borderRadius: size({ p: 1 }),
                                backgroundColor: COLORS.WHITE,
                                border: `1px solid ${COLORS.C2}15`,
                                boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                                transition: "all .35s ease",

                                "&:hover": {
                                    transform: "translateY(-6px)",
                                    boxShadow: "0 18px 40px rgba(0,0,0,.12)",
                                },
                            }}
                        >
                            {/* IMAGE */}
                            <Grid item xs={12} md={4}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        p: 3,
                                        borderRadius: size({ p: 1.5 }),
                                        backgroundColor: "#F8FAFC",
                                    }}
                                >
                                    <CardMedia
                                        component="img"
                                        image={item.image}
                                        alt={item.title}
                                        sx={{
                                            width: "85%",
                                            maxHeight: size({ p: 42, h: true }),
                                            objectFit: "contain",
                                            transition: ".35s",
                                        }}
                                    />
                                </Box>
                            </Grid>

                            {/* CONTENT */}
                            <Grid
                                item
                                xs={12}
                                md={8}
                                container
                                direction="column"
                                sx={{
                                    pl: {
                                        xs: 0,
                                        md: index % 2 === 0 ? 5 : 0,
                                    },
                                    pr: {
                                        xs: 0,
                                        md: index % 2 === 0 ? 0 : 5,
                                    },
                                    mt: {
                                        xs: 4,
                                        md: 0,
                                    },
                                }}
                            >
                                <Grid
                                    container
                                    alignItems="center"
                                    columnGap={2}
                                >
                                    <Typography
                                        sx={{
                                            fontFamily: "Archia",
                                            fontSize: size({ p: 1.8 }),
                                            fontWeight: 700,
                                            color: COLORS.C2,
                                            lineHeight: 1.4,
                                        }}
                                    >
                                        {item.title}

                                        {item.upcoming && (
                                            <Chip
                                                label="Upcoming..."
                                                size="small"
                                                component="span"
                                                sx={{
                                                    ml: 2,
                                                    verticalAlign: "middle",
                                                    color: "#fff",
                                                    fontWeight: 700,
                                                    backgroundColor: "#0891B2",
                                                    animation: "glow 1.6s ease-in-out infinite",

                                                    "@keyframes glow": {
                                                        "0%": {
                                                            boxShadow: "0 0 5px rgba(8,145,178,.35)",
                                                        },
                                                        "50%": {
                                                            boxShadow:
                                                                "0 0 15px rgba(8,145,178,.7), 0 0 28px rgba(8,145,178,.45)",
                                                        },
                                                        "100%": {
                                                            boxShadow: "0 0 5px rgba(8,145,178,.35)",
                                                        },
                                                    },
                                                }}
                                            />
                                        )}
                                    </Typography>
                                </Grid>

                                <Divider
                                    sx={{
                                        width: 70,
                                        borderBottomWidth: 3,
                                        borderColor: COLORS.C2,
                                        my: 3,
                                    }}
                                />

                                <Typography
                                    sx={{
                                        fontFamily: "Archia",
                                        fontSize: size({ p: 1 }),
                                        color: COLORS.C1 + "B0",
                                        lineHeight: 1.9,
                                        textAlign: "justify",
                                    }}
                                >
                                    {item.description}
                                </Typography>

                                {item.buttonText && (
                                    <Button
                                        variant="contained"
                                        component="a"
                                        href={item.href}
                                        target={item.download ? undefined : "_blank"}
                                        rel={item.download ? undefined : "noreferrer"}
                                        download={item.download}
                                        sx={{
                                            mt: 4,
                                            width: "fit-content",
                                            px: 4,
                                            py: 1.2,
                                            borderRadius: "30px",
                                            backgroundColor: COLORS.C2,
                                            color: COLORS.WHITE,
                                            textTransform: "none",
                                            fontFamily: "Archia",
                                            fontWeight: 700,
                                            fontSize: size({ p: 0.95 }),
                                            boxShadow: "none",

                                            "&:hover": {
                                                backgroundColor: COLORS.C4,
                                                boxShadow: "0 10px 20px rgba(0,0,0,.15)",
                                            },
                                        }}
                                    >
                                        {item.buttonText}
                                    </Button>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        </Grid >
    );
}
